const ruleTranslations = {
    min: {
        string: 'Kentän arvon tulee olla vähintään :min merkkiä',
        numeric: 'Kentän arvon tulee olla vähintään :min',
    },
    max: {
        string: 'Kentän arvon tulee olla enintään :max merkkiä',
        numeric: 'Kentän arvon tulee olla enintään :max',
    },
    required: 'Kenttä ei saa olla tyhjä',
    string: 'Kentän arvon tulee olla merkkijono',
    numeric: 'Kentän arvon tulee olla numero',
    regex: 'Kentän arvo on väärässä formaatissa',
};

export default ruleTranslations;
